import './ArrivalSuggestionModal.css';

const CATEGORY_CONFIG = {
  'Felrakó':    { icon: 'ti-package',        color: '#2bb344' },
  'Lerakó':     { icon: 'ti-package-export', color: '#b8862e' },
  'Vámkezelés': { icon: 'ti-building-bank',  color: '#9b59b6' },
};

export default function ArrivalSuggestionModal({ station, distance, onConfirm, onDismiss }) {
  const cfg = CATEGORY_CONFIG[station.category] || { icon: 'ti-map-pin', color: '#8a958c' };

  return (
    <div className="modal-overlay" onClick={onDismiss}>
      <div className="modal-box arrival-modal" onClick={e => e.stopPropagation()}>
        <div className="arrival-modal-header">
          <div className="arrival-icon" style={{ color: cfg.color }}>
            <i className={`ti ${cfg.icon}`}></i>
          </div>
          <div className="arrival-title">Megérkeztél?</div>
        </div>

        <div className="arrival-modal-body">
          <div className="arrival-category" style={{ color: cfg.color }}>
            {station.category}
          </div>
          <div className="arrival-station-name">{station.station_name}</div>
          <div className="arrival-city">
            {station.city}
            {station.country && <span> ({station.country})</span>}
          </div>
          <div className="arrival-distance">
            <i className="ti ti-map-pin"></i>
            {Math.round(distance)} méter távolságra
          </div>
          <div className="arrival-order">
            <i className="ti ti-file-text"></i>
            {station.order_identifier}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onDismiss}>
            Nem, mégsem
          </button>
          <button className="btn-primary" onClick={() => onConfirm(station)}>
            <i className="ti ti-check"></i> Igen, megérkeztem!
          </button>
        </div>
      </div>
    </div>
  );
}